<template>
  <el-popover placement="top-start" :width="650" trigger="hover" @show="getExpect">
    <template #reference>
      <slot name="base"></slot>
    </template>
    <div class="h-250 w-626 overflow-y-auto rounded-[4px] pt-4">
      <table border="1" cellspacing="0">
        <thead>
          <tr height="50">
            <th width="121" scope="col">{{ $t('收藏夹') }}</th>
            <th width="121" scope="col">{{ $t('平台') }}</th>
            <th width="50" scope="col">{{ $t('期望') }}</th>
            <th width="82" scope="col">{{ $t('期望值') }}</th>
            <th width="82" scope="col">{{ $t('当前值') }}</th>
            <th width="185" scope="col">{{ $t('备注') }}</th>
            <th width="106" scope="col">{{ $t('结论') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="platform in platformList" :key="platform.platform" height="60">
            <td align="center">
              <div class="flex items-center justify-center">
                <span>{{ platform.folderName }}</span>
              </div>
            </td>
            <td align="center">
              <div class="flex items-center justify-center">
                <i class="iconfont mr-5" :class="`icon-${platform.platform}`"></i>
                <span>{{ platform.platform }}</span>
              </div>
            </td>
            <td align="center">
              <span :class="platform.expectUpdown ? 'text-red' : 'text-green'">{{ platform.expectUpdown ? $t('涨') : $t('跌') }}</span>
            </td>
            <td align="center">
              <span class="text-black">{{ platform.expectPrice }}</span>
            </td>
            <td align="center">
              <span class="text-price">{{ platform.sellPrice }}</span>
            </td>
            <td align="center">{{ platform.remark }}</td>
            <td align="center">
              <div class="w-70">
                <div
                  v-if="(platform.expectUpdown && platform.sellPrice >= platform.expectPrice) || (!platform.expectUpdown && platform.sellPrice <= platform.expectPrice)"
                  class="mb-5 flex h-28 items-center justify-center rounded-[10px] bg-[#F87600] px-5 text-white"
                >
                  {{ $t('已达预期') }}
                </div>
                <div v-else class="flex h-28 items-center justify-center rounded-[10px] bg-gray-light px-5 text-white">{{ $t('未达预期') }}</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-popover>
  <!-- <mytooltip :placement="'bottom'" :class="'target-tips'">
    <template #content>
      
    </template>
    <slot name="base"></slot>
  </mytooltip> -->
</template>

<script setup>
import { getCollectExpect } from '~~/api/collect'
const props = defineProps({
  row: Object,
  folderId: String,
  folder: Object
})

const platformList = ref([])

const getExpect = async () => {
  const res = await getCollectExpect({
    itemId: props.row.itemId,
    folderId: props.folderId
  })

  if (props.folder && props.folder.folderId) {
    const folderId = props.folder.folderId
    platformList.value = res.data.sort((a, b) => {
      return a.folderId === folderId ? -1 : 1
    })
  }
  platformList.value = res.data
}
</script>

<style lang="scss" scoped>
table,
table tr th,
table tr td {
  border: 1px solid #eff1f5;
}

table {
 
  td {
    color: #777;
  }
}
</style>

<style>
.target-tips {
  padding: 0 !important;
}
</style>
